enum ConfirmDialogTypes {
  INVITE = 'invite',
  DELETE = 'delete',
  SET_NOT_INVITED = 'set-not-invited',
  APPROVE = 'approve',
}

export default ConfirmDialogTypes
